import { useEffect, useState } from 'react';
import CheckoutFloatingAlertStore from '../checkout/CheckoutFloatingAlertStore';

// Module-level state to track which component should render the global FloatingAlertList
let isGlobalAlertListRendered = false;
export const useGlobalAlertStore = () => {
  const [shouldRenderGlobalList, setShouldRenderGlobalList] = useState(false);
  useEffect(() => {
    if (!isGlobalAlertListRendered) {
      isGlobalAlertListRendered = true;
      setShouldRenderGlobalList(true);
    }
    return () => {
      // Only reset if THIS component was the one rendering the list
      if (shouldRenderGlobalList) {
        isGlobalAlertListRendered = false;
        setShouldRenderGlobalList(false);
      }
      // If shouldRenderGlobalList is false, this component wasn't rendering, so no-op
    };
  }, [shouldRenderGlobalList]);
  return {
    store: CheckoutFloatingAlertStore,
    shouldRenderGlobalList
  };
};

// Test utility to reset module state between test runs
export const resetGlobalAlertState = () => {
  isGlobalAlertListRendered = false;

  // Clear any existing alerts from the shared store
  CheckoutFloatingAlertStore.resetStore();
};